<template>
  <v-card class="d-flex justify-center align-center" flat>
    <v-expand-x-transition>
      <!-- Example of logo, must change in future-->

      <!-- <router-link
      :to="homeRoute"
      class="router-link"
      @click="eventBus.$emit('nav-clicked')"
    > -->
      <img
        v-show="expanded || isMobile"
        :src="require(`@/../public/${asset}/logo.png`)"
        :style="imageStyle"
        class="pl-3 box"
        alt="logo"
      />
    </v-expand-x-transition>

    <img
      v-show="!expanded && !isMobile"
      :src="require(`@/../public/${asset}/android-icon-48x48.png`)"
      class="Logo"
      alt="logo"
    />
    <!-- </router-link> -->
  </v-card>
</template>

<script>
export default {
  name: "Logo",
  props: {
    name: String,
    logged: {
      type: Boolean,
      default: false,
    },
    expanded: Boolean,
    isMobile: Boolean,
  },
  data() {
    return {
      asset: process.env.VUE_APP_PUBLIC_ASSETS,
      homeRoute: `/${process.env.VUE_APP_HOME_ROUTE}`,
    };
  },
  computed: {
    imageStyle() {
      let style = {};
      return style;
    },
  },
};
</script>

<style lang="css" scoped>
.Logo {
  height: 30px;
  width: 30px;
  padding-left: 1px;
}
img {
  width: 90%;
  height: 100%;
}

.box {
  width: 125px;
  max-height: 44px;
}
</style>
